import React from 'react';
import styled from 'styled-components';
import { useAuth } from '../../shared/hooks/useApi/useAuth';
import { DeviceType, MemberType, ModalType } from '../../shared/enum/EnumRepository';
import MoleculeDivBtn from '../../shared/component/molecule/MoleculeDivBtn';
import { useModalStore } from '../../shared/store/portal/modalStore';
import { UpdateSettingReq } from '../../shared/dto/ReqDtoRepository';
import { useSetting } from '../../shared/hooks/useApi/useSetting';
import { useDeviceStore } from '../../shared/store/deviceStore';
import { getSettingsMessage } from '../../shared/constants/pageMessages';

const MemberSetting: React.FC = () => {
  const { user } = useAuth();
  const { setStandardModal } = useModalStore();
  const { setting, updateSetting } = useSetting();
  const { deviceType } = useDeviceStore();

  if (!user || !setting) return null;

  const activityType = setting.memberType === MemberType.GROUP
    ? 'Group'
    : setting.archiveRole
      ? setting.archiveRole.charAt(0) + setting.archiveRole.slice(1).toLowerCase()
      : '-';

  const handleChangeUsername = () => {
    setStandardModal({
      modalType: ModalType.CHANGE_USERNAME,
      title: "Username",
      value: setting.username,
      handleChange: (value: string) => handleUpdateSetting('username', value)
    });
  }

  const handleUpdateSetting = async (field: keyof UpdateSettingReq, value: string | boolean) => {
    const payload: UpdateSettingReq = {
      id: setting.id,
      username: setting.username,
      exposureLevel: setting.exposureLevel,
      menuVisible: setting.menuVisible,
      navLayout: setting.navLayout,
    };
    if (field === 'username' && typeof value === 'string') {
      payload.username = value;
    }
    await updateSetting(payload);
  }

  const handleChangeHandle = () => {
    setStandardModal({
      modalType: ModalType.CHANGE_HANDLE,
      title: "Link ID",
      value: setting.handle,
      handleChange: () => { }
    });
  }

  const handleChangePw = () => {
    setStandardModal({
      modalType: ModalType.CHANGE_PW,
      title: "Password",
      value: "",
      handleChange: () => { }
    });
  }

  return (
    <MemberSettingComp>
      <Title>Profile</Title>
      <SubContainer>
        <SubWrapper>
          <SubTitle>Link ID
            <SubExplain>{getSettingsMessage('LINK_ID_EXPLAIN')}</SubExplain>
          </SubTitle>
          <MoleculeDivBtn
            value={"www.architrave.work/@" + setting.handle}
            defaultValue={setting.handle}
            handleClick={handleChangeHandle}
            DivChangeStyle={deviceType === DeviceType.MOBILE ? SubValueChangeMobile : SubValueChange}
            DivStyle={SubValue}
          />
        </SubWrapper>
        <SubWrapper>
          <SubTitle>Username
            <SubExplain>{getSettingsMessage('USERNAME_EXPLAIN')}</SubExplain>
          </SubTitle>
          <MoleculeDivBtn
            value={setting.username}
            defaultValue={setting.username}
            handleClick={handleChangeUsername}
            DivChangeStyle={deviceType === DeviceType.MOBILE ? SubValueChangeMobile : SubValueChange}
            DivStyle={SubValue}
          />
        </SubWrapper>
        <SubWrapper>
          <SubTitle>{getSettingsMessage('SETTINGS_EMAIL')}</SubTitle>
          <SubValue>{user.email}</SubValue>
        </SubWrapper>
        <SubWrapper>
          <SubTitle>{getSettingsMessage('SETTINGS_PASSWORD')}</SubTitle>
          <MoleculeDivBtn
            value={""}
            defaultValue={"********"}
            handleClick={handleChangePw}
            DivChangeStyle={deviceType === DeviceType.MOBILE ? SubValueChangeMobile : SubValueChange}
            DivStyle={SubValue}
          />
        </SubWrapper>
        <SubWrapper>
          <SubTitle>{getSettingsMessage('SETTINGS_ACTIVITY_TYPE')}</SubTitle>
          <SubValue>{activityType}</SubValue>
        </SubWrapper>
      </SubContainer>
    </MemberSettingComp>
  );
}

const MemberSettingComp = styled.section`
  width: clamp(320px, 65%, 650px);
  height: fit-content;
  display: flex;
  flex-direction: column;
  margin-top: 48px;
  margin-bottom: 30px;
`;

export const Title = styled.div`
  width: fit-content;
  border-bottom: 1.6px solid ${({ theme }) => theme.colors.color_Gray_02};

  padding: 4px 0px;
  padding-right: 6px;
  margin-bottom: 8px;
  ${({ theme }) => theme.typography.Body_03_1};
`;

export const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
export const SubWrapper = styled.div`
`;

export const SubTitle = styled.div`
  width: fit-content;
  padding: 4px 0px;
  ${({ theme }) => theme.typography.Body_04};
`;

export const SubExplain = styled.div`
  width: fit-content;
  padding-top: 4px;
  color: ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Body_04};
`

export const SubBtnValue = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SubValue = styled.div`
  width: fit-content;
  padding: 4px 0px;
  ${({ theme }) => theme.typography.Body_04};
`;

export const SubValueChange = styled.div`
  width: 100%;
  padding: 4px 0px;
  
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Body_04};
`;


export const SubValueChangeMobile = styled.div`
  width: 100%;
  padding: 0.4rem 0;
  
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Body_04};
`;

export default MemberSetting;
